import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { RootState } from 'model/state';
import { Dispatch } from 'redux';
import { AutoShutoffModal } from 'components';
import { selectIsSubmittingThresholds, selectThresholdSettings } from 'selectors/Settings';
import { ThresholdSettings, Location } from 'model';
import { fetchThresholdSettings, updateThresholdsSettings, saveAutoShutoffSettings, clearMessage } from 'actions';
import { selectHasErrorMessage } from 'selectors';

type SelectedValues = {
  isSubmitting: boolean,
  thresholds: ThresholdSettings | null,
  hasError: boolean,
}

const mapStateToProps = createStructuredSelector<RootState, SelectedValues>({
  isSubmitting: selectIsSubmittingThresholds(),
  thresholds: selectThresholdSettings(),
  hasError: selectHasErrorMessage(),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchThresholdSettings: (locations: Location[]) => dispatch(fetchThresholdSettings(locations)),
  updateThresholdsSettings: (settings: ThresholdSettings) => dispatch(updateThresholdsSettings(settings)),
  saveThresholdSettings: (locationIds: string[], settings: ThresholdSettings) => dispatch(saveAutoShutoffSettings(locationIds, settings)),
  clearMessage: () => dispatch(clearMessage()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AutoShutoffModal);
